import React, { useContext, useEffect,useState,useRef  } from "react";
import { useNavigate  } from 'react-router-dom';

//import ReactGA from 'react-ga4';
import helpersFunction from '../_helpers/helpersFunction';
import Context from '../context/context';


export default function PopupModale(props) {

    const [icebreaker, setIcebreaker] = useState(false);
  const {collection_folder, default_folder} = helpersFunction.getCDNfolder()
    const [messaggio, setMessage] = useState('');
    const [sent, setSent] = useState(false);
    const context = useContext(Context);
    let navigate = useNavigate();

    const trackerId = localStorage.getItem('trackerId');
    const token = localStorage.getItem('token');

    const formMessaggio = useRef(null);

    useEffect(()=>{
        if(props.character.id){
           getChatHistory(props.character.id)
        }
        
    },[props.character.id])


    useEffect(()=>{
        if(sent){
            setTimeout(()=>{
                setSent(false)
                props.onHide()
                props.inviteSent("right", props.character.id,props.character["_id"])
            },4000)
        }
        
    },[sent])


    async function getChatHistory(angelID){
       
       

        const url = process.env.REACT_APP_APIADDRESS+"/get/messages/"+trackerId+"/"+angelID;
        fetch(url,{ 
            method: 'get', 
            headers: {
                'Authorization': 'Bearer '+ token
            }
        })
        .then(response => response.json())
        .then(data => {
            
            const icebreaker = is_icebreaker(data)
            console.log("ICEBREAKER?",icebreaker)
            icebreaker ? setIcebreaker(true) : setIcebreaker(false)
            
        });
    }


    function is_icebreaker(messaggi){
        for (let i = 0; i < messaggi.length; i++){
            if(messaggi[i].type == "personal"){
                return false    
            }    
        }
        return true
    }


    

    function controlloInvio(){
        const creditiMessaggi = parseInt(context.creditiMessaggi);
        const creditiIcebreaker = parseInt(context.creditiIcebreaker);
        const valoreMessaggio = context.premiumLevel == 0 ? 1 : context.valoreMessaggio;
    
        console.log("icebreaker", icebreaker);
    
        if(context.premiumLevel == 0){
            // UTENTI FREE
            if(icebreaker){
                if(creditiIcebreaker > 0){
                    console.log("ok icebreaker");
                    return true;
                } else if(creditiMessaggi > 0){
                    console.log("ok messaggi");
                    // CASISTICA AGGIUNTA: fallback ai crediti messaggi
                    return true;
                } else {
                    console.log("ko icebreaker");
                    helpersFunction.eventPost(trackerId, props.character.id, "ko_icebreaker");
                    return false;
                }
            } else {
                // Messaggio normale: controlla crediti messaggi
                if(creditiMessaggi > 0){
                    return true;
                } else {
                    helpersFunction.eventPost(trackerId, props.character.id, "ko_msg");
                    return false;
                }
            }
        } else {
           
            // Messaggio normale
            const saldo = creditiMessaggi - valoreMessaggio;
            if(creditiMessaggi > 0 && saldo >= 0){
                return true;
            } else {
                helpersFunction.eventPost(trackerId, props.character.id, "ko_msg");
                return false;
            }
    
        }
    }

  


    function hookToChatSubmit(event){

        var time = new Date();
        
        if (event.preventDefault){
            event.preventDefault(); 
        }
        //ReactGA.event({ category: 'User',action: 'Messaggio inviato',label:trackerId})
        var blurred= true
    
       const country = helpersFunction.getCountry()
        
            if(messaggio != ""){
                //--- controllo se può mandare considerando crediti e icebreaker
                var abilitato = controlloInvio()		
                console.log("ABILITATO",abilitato)
                if(abilitato){
                    //ReactGA.event({ category: 'User',action: 'Messaggio inviato - OK',label:trackerId})
    
                    if(context.premiumLevel > 0){
                        blurred= false
                    }
    
                    context.Socket.emit('chat', {'msg' : messaggio, 'trackerId': trackerId, 'angelId':props.character.id,"screenName":props.character.screenName,"servizio": window.location.hostname,"country":country,"time":time, "blurredMessage":blurred, "icebreaker": icebreaker, "provider": context.flusso.provider_animazione});
                    setSent(true)

                    const tipologia_messaggio = icebreaker ? "icebreaker" : "no_icebreaker";
                    helpersFunction.kpiPanel(context,"ivio_msg_chat",tipologia_messaggio)
                    setIcebreaker(false)

                }else{

                    if(context.premiumLevel == 0){
                        context.setMessaggioPending({'msg' : messaggio, 'trackerId': trackerId, 'angelId':props.character.id,"screenName":props.character.screenName,"servizio": window.location.hostname,"country":country,"time":time, "blurredMessage":blurred, "precompilato": false, "icebreaker":icebreaker, "provider": context.flusso.provider_animazione })
                    }

                    helpersFunction.showHook("fine_crediti",props.character,context,navigate)
                   
                }
            }
        
      }
    
      const handleInputChange = (e) => {
        setMessage(e.target.value); // Aggiorna lo stato con il valore del textarea
      };
    

    return (<>
        <div className="modale_invito">
            <div className="modal_card">
                <div className="modal_photo_box">
                    <div className="modal_photo_header">
                        <h5 className="modal_photo_title"></h5>
                        <span className="modal_photo_close" onClick={()=>{props.onHide();if(sent){props.inviteSent("right", props.character.id,props.character["_id"])}}}>x</span>
                    </div>
                    <img className="modal_photo_img" src={
                         props.character.default_photo.startsWith("https://") ? props.character.default_photo : process.env.REACT_APP_CDN+'/'+default_folder+'/' + props.character.id + '.jpg'}></img>
                </div>
                <div className="modal_photo_bottom">
                    <div className="modal_photo_bottom_content">
                        <div className="d-flex flex-column align-items-center h-100">
                            {!sent && (<>
                                <div className="rounded-icon-invite">
                                <svg width="48" height="40" viewBox="0 0 48 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                     <path d="M43.0276 0.540527H4.97355C2.35734 0.540527 0.216797 2.72972 0.216797 5.40539V34.5946C0.216797 37.2703 2.35734 39.4594 4.97355 39.4594H43.0276C45.6438 39.4594 47.7844 37.2703 47.7844 34.5946V5.40539C47.7844 2.72972 45.6438 0.540527 43.0276 0.540527ZM42.0763 10.8784L26.5217 20.827C24.9757 21.8243 23.0254 21.8243 21.4795 20.827L5.92491 10.8784C5.33031 10.4892 4.97355 9.83242 4.97355 9.12701C4.97355 7.49728 6.70977 6.52431 8.06545 7.37566L24.0006 17.5676L39.9357 7.37566C41.2914 6.52431 43.0276 7.49728 43.0276 9.12701C43.0276 9.83242 42.6709 10.4892 42.0763 10.8784Z" fill="#ED1E79"/>
                                </svg>
                                </div>
                                <div className="title_invite">Manda un invito</div>
                                <div className="mt-4">
                                    <div className="row_animation_content">
                                        <div className="animation_white"></div>
                                    </div>
                                </div>
                                <div className="modal_photo_form">
                                    <form ref={formMessaggio}  onSubmit={(e) => hookToChatSubmit(e)}>
                                        <textarea id="photo_content_input_invite" placeholder="Scrivi un messaggio" onChange={handleInputChange} value={messaggio}></textarea>
                                        <button className={`photo_content_button ${messaggio != "" ? 'on' : ''}`}>Invia</button>
                                    </form>
                                </div>
                                </>)}
                            
                            {sent && (<>

                            <div className="rounded-icon-invite">
                                <svg width="53" height="53" viewBox="0 0 53 53" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="26.5" cy="26.5" r="25" fill="white" stroke="white" stroke-width="3"/>
                                    <g clip-path="url(#clip0_2308_7652)">
                                    <path d="M40.676 12.0707L22.9429 41.2754C22.5854 41.8645 21.7532 41.8928 21.3575 41.3295L12.3426 28.4938C12.0179 28.0321 12.5434 27.447 13.0251 27.7342L21.5623 32.8271L39.8458 11.4491C40.2629 10.9611 41.01 11.521 40.676 12.0712V12.0707Z" fill="#ED1E79"/>
                                    <path d="M22.1314 43.0004C21.423 43.0004 20.7599 42.6545 20.3462 42.0653L11.3313 29.2296C10.8436 28.5353 10.8983 27.6109 11.464 26.9808C12.0298 26.3512 12.9301 26.2126 13.6534 26.6445L21.3012 31.2069L38.9081 10.6199C39.5151 9.90985 40.5347 9.79556 41.2794 10.3533C42.0241 10.9111 42.2194 11.9357 41.7332 12.7357L23.9997 41.9404C23.6124 42.5781 22.9418 42.9736 22.2055 42.9989C22.1807 42.9999 22.1558 43.0004 22.1309 43.0004H22.1314ZM15.3327 30.5768L22.1145 40.2337L34.9405 19.1111L21.8232 34.449L15.3327 30.5768ZM39.6185 11.4072C39.6185 11.4072 39.618 11.4082 39.6175 11.4087L39.6185 11.4072Z" fill="#ED1E79"/>
                                    </g>
                                    <defs>
                                    <clipPath id="clip0_2308_7652">
                                    <rect width="31" height="33" fill="white" transform="translate(11 10)"/>
                                    </clipPath>
                                    </defs>
                                </svg>
                            </div>
                            <div className="title_invite">
                                <span className="colored">{props.character.screenName}</span><br/> 
                                <h4>HA RICEVUTO IL TUO INVITO!</h4>
                                <h5 style={{marginBottom:"60px"}}>Se accetta potrai iniziare a chattare con lei</h5>
                            </div>
                                
                            </>)}
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>)
}